import { all, call, put, select } from 'redux-saga/effects';
import { markAsRead } from '../../../api/messageApi';
import { getUnreadCountRequest, refreshMessagesRequest } from '../../actions/messageActions';
import { errorHandler } from '../errorSaga';

export function* markAsReadRequestHandler({ payload }) {
  try {
    const isAuthenticated = yield select((state) => state.auth.isAuthenticated);
    if (!isAuthenticated) {
      // 未ログイン時はスキップ
      return;
    }
    const { messageId, isIndividual, channel } = payload;
    yield call(markAsRead, { messageId });
    yield all([put(getUnreadCountRequest({ channel })), put(refreshMessagesRequest({ isIndividual, channel }))]);
  } catch (error) {
    // TODO 暗黙の更新で画面側にエラーを通知してしまって良いのかどうか
    yield call(errorHandler, { error });
  }
}
